import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  setHistorySortAscending,
  setHistorySortDescending
} from "../../actions/historyActions";

import DropDown from "./DropDown";

export function SortSelection({ hasMore, sortDir, setSortAscending, setSortDescending }) {
  const label = `DATE ${sortDir.toUpperCase()}`;

  return (
    <DropDown
      preLabel="Sorting : "
      label={label}
      disabled={hasMore}
    >
      <li>
        <a onClick={setSortAscending} href="#">DATE ASC</a>
      </li>
      <li>
        <a onClick={setSortDescending} href="#">DATE DESC</a>
      </li>
    </DropDown>
  );
}

SortSelection.displayName = "History.SortSelection";

SortSelection.propTypes = {
  hasMore: PropTypes.bool.isRequired,
  setSortAscending: PropTypes.func.isRequired,
  setSortDescending: PropTypes.func.isRequired,
  sortDir: PropTypes.oneOf(["asc", "desc"]).isRequired,
};

SortSelection.defaultProps = {
  hasMore: true,
  sortDir: "desc"
};

function mapStateToProps(state, ownProps) {
  return {
    hasMore: state.entries.hasMore,
    sortDir: state.historyFilters.sortDir,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    setSortAscending: () => dispatch(setHistorySortAscending()),
    setSortDescending: () => dispatch(setHistorySortDescending()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SortSelection);



// WEBPACK FOOTER //
// ./app/components/History/SortSelection.jsx